/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Has obtenido una justificación empresarial para acceder a los datos de los clientes"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Se hará un seguimiento de tu actividad de descarga y se registrará por motivos de seguridad"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "¿Quieres continuar?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Al efectuar la descarga, reconoces lo siguiente:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
